import React, { PropTypes, Component } from 'react';
import { Paper } from 'material-ui';
// import SortableList from '../../tc-ui/sortable-list-with-react-dnd/sortable-list';
// import DraggableCard from '../../tc-ui/sortable-list-with-react-dnd/draggable-card';
import Pagination from '../../tc-ui/pagination/pagination';
import GeneratePreview from '../generate-preview';
import MediaFileDialog from '../media-file-dialog';
import { contains, ifElse } from 'ramda';

class DragDropFiles extends Component {
  constructor() {
    super();
    this.state = { page: 1 };
  }
  goToPage = (page) => this.setState({ page });

  render() {
    const {
      filesArray,
      isEditable,
      deleteFileFunc,
      dragEndsFunc,
      cardStyle,
      isUpdating,
      onThumbnailSelect,
      onThumbnailUnselect,
      selectedFiles,
      onPreviewClick,
      openPreview,
      closePreview,
      updateUserHovering,
      isUserHovering,
      updateFileName,
      downloadOneFile,
      uploadingFile,
      indexToOpen,
      changeFileIndex,
      forLocationOrProductPages,
      removeIndividualTag,
    } = this.props;
    const page = Math.min(Math.ceil(filesArray.length / 5), this.state.page);
    const showPagination = filesArray.length > 5;
    const getFileName = (fileName) => {
      if (isEditable) {
        return (
          <div
            style={{
              position: 'absolute',
              backgroundColor: 'rgba(138,138,138,.5)',
              color: '#ffffff',
              display: 'block',
              bottom: '16px',
              marginLeft: '16px',
              width: '128px',
              // cursor: 'move',
              cursor: 'default',
              textAlign: 'center',
              maxHeight: '23px',
              overflowX: 'hidden',
              textOverflow: 'ellipsis',
              overflowY: 'hidden',
            }}
          >
            <span>{fileName}</span>
          </div>
        );
      }
    };

    // UNDOING DRAG AND DROP FOR NOW
    // const dragDrop = () => {
    //   return (
    //     <SortableList
    //       arrayOfData={filesArray}
    //       dragEnds={(updatedArrangement) => dragEndsFunc(updatedArrangement)}
    //       cardStyle={cardStyle}
    //     >
    //       {
    //         filesArray.map((file, index) => {
    //           const photoClass = (file === true || isUpdating && index === filesArray.length - 1) ?
    //             'image-loading-indicater black-border' : '';
    //           const arrayOfSelectedUrls = selectedFiles.map(obj => obj.url);
    //           return (
    //             <DraggableCard
    //               style={{ position: 'relative', display: 'inline-block' }}
    //               key={index}
    //               isDragSource={isEditable}
    //               isDropTarget={isEditable}
    //             >
    //               <Paper
    //                 zDepth={1}
    //                 style={{
    //                   width: '128px',
    //                   display: 'inline-block',
    //                   margin: '16px',
    //                   cursor: 'pointer',
    //                 }}
    //               >
    //                 <div key={index} style={{ height: '100%', position: 'relative' }}>
    //                   <div
    //                     style={{
    //                       width: '128px',
    //                       height: '128px',
    //                       lineHeight: '128px',
    //                       position: 'relative',
    //                       color: 'white',
    //                       backgroundColor: '#f5f5f5',
    //                       textAlign: 'center',
    //                     }}
    //                     className={photoClass}
    //                   >
    //                     <GeneratePreview
    //                       index={index}
    //                       file={file}
    //                       hoverEffect
    //                       onThumbnailSelect={ifElse(
    //                         () => contains(file.url, arrayOfSelectedUrls),
    //                           () => onThumbnailUnselect(selectedFiles.filter(object => object.url !== file.url)),
    //                         (clickedFile) => onThumbnailSelect(clickedFile)
    //                       )}
    //                       selectedBorderStyle={{ outline: '2px solid #00bcd4' }}
    //                       isSelected={contains(file.url, arrayOfSelectedUrls)}
    //                       onPreviewClick={() => onPreviewClick(file, index)}
    //                       updateUserHovering={updateUserHovering}
    //                       isUserHovering={isUserHovering}
    //                       showVideoControls={false}
    //                       isUploadingFile={uploadingFile}
    //                     />
    //                   </div>
    //                 </div>
    //               </Paper>
    //               {getFileName(file.name)}
    //             </DraggableCard>
    //           );
    //         })
    //       }
    //     </SortableList>
    //   );
    // };

    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}>
          {
            filesArray.slice((page - 1) * 5, page * 5).map((file, i) => {
              const index = i + (page - 1) * 5;
              const photoClass = (file === true || isUpdating && index === filesArray.length - 1) ?
                'image-loading-indicater black-border' : '';
              const arrayOfSelectedUrls = selectedFiles.map(obj => obj.url);
              return (
                <div style={{ position: 'relative', display: 'inline-block' }} key={index}>
                  <Paper
                    zDepth={1}
                    style={{
                      width: '128px',
                      display: 'inline-block',
                      margin: '16px',
                      cursor: 'pointer',
                    }}
                  >
                    <div style={{ height: '100%', position: 'relative' }}>
                      <div
                        style={{
                          width: '128px',
                          height: '128px',
                          lineHeight: '128px',
                          position: 'relative',
                          color: 'white',
                          backgroundColor: '#f5f5f5',
                          textAlign: 'center',
                        }}
                        className={photoClass}
                      >
                        <GeneratePreview
                          index={index}
                          file={file}
                          hoverEffect
                          onThumbnailSelect={ifElse(
                            () => contains(file.url, arrayOfSelectedUrls),
                            () => onThumbnailUnselect(selectedFiles.filter(object => object.url !== file.url)),
                            (clickedFile) => onThumbnailSelect(clickedFile)
                          )}
                          selectedBorderStyle={{ outline: '2px solid #00bcd4' }}
                          isSelected={contains(file.url, arrayOfSelectedUrls)}
                          onPreviewClick={() => onPreviewClick(file, index)}
                          updateUserHovering={updateUserHovering}
                          isUserHovering={isUserHovering}
                          showVideoControls={false}
                          isUploadingFile={uploadingFile}
                        />
                      </div>
                    </div>
                  </Paper>
                  {getFileName(file.name)}
                </div>
              );
            })
          }
        </div>
        {
          showPagination && (
            <Pagination
              currentPage={page}
              totalPages={Math.ceil(filesArray.length / 5)}
              goToPage={this.goToPage}
              noOfPagesToShow={5}
            />
          )
        }
        <div>
          {
            openPreview && selectedFiles.length > 0 ?
              <MediaFileDialog
                closePreview={closePreview}
                previewFiles={filesArray}
                open={openPreview}
                isEditable={isEditable}
                downloadOneFile={downloadOneFile}
                deleteFileFunc={deleteFileFunc}
                editFileNameFunc={(updatedFile) => {
                  if (forLocationOrProductPages) {
                    updateFileName(undefined, updatedFile);
                  } else {
                    filesArray[indexToOpen] = updatedFile;
                    updateFileName(filesArray, updatedFile);
                  }
                }}
                indexToOpen={indexToOpen}
                changeFileIndex={changeFileIndex}
                forLocationOrProductPages={forLocationOrProductPages}
                removeIndividualTag={removeIndividualTag}
              /> : <span/>
          }
        </div>
      </div>
    );
  }
}

DragDropFiles.propTypes = {
  filesArray: PropTypes.array,
  isEditable: PropTypes.bool,
  deleteFileFunc: PropTypes.func,
  dragEndsFunc: PropTypes.func,
  cardStyle: PropTypes.object,
  isUpdating: PropTypes.bool,
  onThumbnailSelect: PropTypes.func,
  selectedFiles: PropTypes.array,
  onThumbnailUnselect: PropTypes.func,
  onPreviewClick: PropTypes.func,
  openPreview: PropTypes.bool,
  closePreview: PropTypes.func,
  updateUserHovering: PropTypes.func,
  isUserHovering: PropTypes.bool,
  updateFileName: PropTypes.func,
  downloadOneFile: PropTypes.func,
  uploadingFile: PropTypes.bool,
  indexToOpen: PropTypes.number,
  changeFileIndex: PropTypes.func,
  forLocationOrProductPages: PropTypes.bool,
  removeIndividualTag: PropTypes.func,
};

export default DragDropFiles;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/drag-drop/drag-drop-files.jsx